import React, { FC } from 'react';
import { Pie } from '@ant-design/charts';
import { useTranslation } from 'react-i18next';
import { Card } from 'antd';

const TopCountriesChart: FC = () => {
  const [t] = useTranslation();
  const [tc] = useTranslation('countries');

  const data = [
    {
      type: tc('AE'),
      value: 76240,
    },
    {
      type: tc('IN'),
      value: 8254,
    },
    {
      type: tc('SA'),
      value: 8254,
    },
    {
      type: tc('GB'),
      value: 1743,
    },
    {
      type: tc('CN'),
      value: 230,
    },
    {
      type: tc('RU'),
      value: 140,
    },
  ];

  const config = {
    appendPadding: 10,
    data,
    angleField: 'value',
    colorField: 'type',
    radius: 0.8,
    label: {
      // type: 'inner',
      // offset: '-30%',
      content: function content(_ref: any) {
        const { percent } = _ref;
        return ''.concat((percent * 100).toFixed(2), '%');
      },
      // style: {
      //   fontSize: 14,
      //   textAlign: 'center',
      // },
    },
    interactions: [{ type: 'element-active' }],
    legend: {
      position: 'bottom' as any,
      layout: 'vertical' as any,
      maxHeight: 900,
      flipPage: false,
    },
  };

  return (
    <Card title={t('topCountries')}>
      <Pie {...config} height={576} />
    </Card>
  );
};

export default TopCountriesChart;
